import axios from '../axios-init';

export const getPaymentRequest4Warehouse = params => {
    return axios.post(`/payment_warehouse/getPayments`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const addPaymentRequest4Warehouse = params => {
    return axios.post(`/payment_warehouse/saveOrUpdateById`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const editPaymentStatus4Warehouse = params => {
    return axios.post(`/payment_warehouse/updatePaymentStatus`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const queryPaymentById4Warehouse = params => {
    return axios.post(`/payment_warehouse/queryPaymentInfo`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const pay4Warehouse = params => {
    return axios.post(`/payment_warehouse/pay`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};



// WEBPACK FOOTER //
// ./src/api/paymentService4Warehouse.js